module.exports = __webpack_public_path__ + "media/images/cleaning/koceila@2x-d5b0767431497cffc07574257d5b0a9d.jpg";